import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { components, GroupBase, SingleValueProps } from 'react-select';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import { LFControllerWrapper } from '@app/_components/form-control/LFControllerWrapper';
import { LFSelect } from '@app/_components/form-control/selects';
export interface ISoilOption {
  label: string;
  value: string;
  color: string;
}
export const SoilObsSingleValue: FC<SingleValueProps<ISoilOption, false, GroupBase<ISoilOption>>> = observer(props => {
  const {
    t
  } = useTranslation();
  return <components.SingleValue {...props}>
      <div className="flex flex-row items-center">
        <div className="flex h-10 min-h-10 w-10 min-w-10 items-center border border-spindle" style={{
        backgroundColor: `${props.getValue()[0]?.color}`
      }}></div>
        <span className="ml-5">{t(String(props.children))}</span>
      </div>
    </components.SingleValue>;
});
export const soilTypeOptions = [{
  value: 'sandy',
  label: 'sandy',
  color: '#F3E0C7'
}, {
  value: 'sandy_loam',
  label: 'sandy_loam',
  color: '#CFBFA3'
}, {
  value: 'sandy_clay_loam',
  label: 'sandy_clay_loam',
  color: '#E2BF8C'
}, {
  value: 'sandy_clay',
  label: 'sandy_clay',
  color: '#E0AC54'
}, {
  value: 'loamy_sand',
  label: 'loamy_sand',
  color: '#DDCFBE'
}, {
  value: 'loamy',
  label: 'loamy',
  color: '#C3A780'
}, {
  value: 'clay_loam',
  label: 'clay_loam',
  color: '#CEA76A'
}, {
  value: 'clay',
  label: 'clay',
  color: '#CA8200'
}, {
  value: 'silty_clay',
  label: 'silty_clay',
  color: '#B78534'
}, {
  value: 'silty_clay_loam',
  label: 'silty_clay_loam',
  color: '#B78534'
}, {
  value: 'silty_loam',
  label: 'silty_loam',
  color: '#9E8C6F'
}, {
  value: 'silt',
  label: 'silt',
  color: '#73624B'
}, {
  value: 'no_data',
  label: 'no_data',
  color: '#FFFFFF'
}, {
  value: 'other',
  label: 'other',
  color: '#262628'
}];
interface ISoilDropdown<T extends FieldValues> {
  control: Control<T>;
  inputName: FieldPath<T>;
}
export const SoilDropdown = observer(<T extends FieldValues,>({
  control,
  inputName
}: ISoilDropdown<T>) => {
  const {
    t
  } = useTranslation();
  return <LFControllerWrapper<T> inputName={inputName} control={control}>
        <LFSelect<ISoilOption> label={t('soilTypeColor')} options={soilTypeOptions.map(x => ({
      ...x,
      label: t(x.label)
    }))} customComponents={{
      SingleValue: SoilObsSingleValue
    }} />
      </LFControllerWrapper>;
});